function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import { requiredImage, simpleBlockContent } from '../fragments/index.js';
import callToAction from './callToAction.js';
var schema = defineObject('imageActionCard', {
    image: _object_spread({
        title: 'Image'
    }, requiredImage.fragment),
    title: {
        type: 'string',
        title: 'Title',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment),
    actions: {
        type: 'array',
        title: 'Actions',
        of: [
            {
                type: 'callToAction'
            }
        ]
    }
}, [
    callToAction.schema.callToAction
]);
var validator = z.object({
    _type: z.literal('imageActionCard'),
    image: requiredImage.validator.optional(),
    title: z.string().optional(),
    description: simpleBlockContent.validator.optional(),
    actions: z.array(callToAction.validator).optional()
});
schema.imageActionCard;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=imageActionCard.js.map